import { render } from "./SearchSubmissions.vue?vue&type=template&id=c993b5c8&scoped=true"
import script from "./SearchSubmissions.vue?vue&type=script&lang=js"
export * from "./SearchSubmissions.vue?vue&type=script&lang=js"

import "./SearchSubmissions.vue?vue&type=style&index=0&id=c993b5c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c993b5c8"]])

export default __exports__